<template>
  <div>
    <descriptionCmp
      v-if="paramsArr.length"
      :paramsArr="paramsArr"
      @changes="descChange"
    ></descriptionCmp>
    <zkNoData v-else></zkNoData>
  </div>
</template>

<script>
import { getDeviceOptions, setOptions } from '@/services/deviceApi.js'
import descriptionCmp from '@/components/description.vue'
import { getByType } from '@/cdpBase/services/dictionary.js'

export default {
  props: ['devSn'],
  components: {
    descriptionCmp
  },
  data() {
    return {
      paramsArr: [],
      switchArr: [],
      selectArr: [],
      sliderArr: [],
      inputArr: []
    }
  },
  methods: {
    loadDeviceOptions() {
      let params = { devSn: this.devSn }
      getDeviceOptions(params)
        .then(async data => {
          if (data.code === '00000000') {
            const { optionsList } = data.payload || []
            this.switchArr = []
            this.selectArr = []
            this.sliderArr = []
            this.inputArr = []
            this.paramsArr = []
            try {
              for (let item of optionsList) {
                if (item.valueType === '1') {
                  this.switchArr.push(item)
                } else if (item.valueType === '2') {
                  let getOptionsList = async () => {
                    let result = await getByType(item.dictionaryType)

                    return result.results.results
                  }

                  item.optionsList = await getOptionsList()

                  this.selectArr.push(item)
                } else if (item.valueType === '3') {
                  item.optionValue = +item.optionValue
                  let getMaxMinValue = async () => {
                    let result = await getByType(item.dictionaryType)

                    return result.results.results
                  }
                  let result = await getMaxMinValue()
                  if (!result) {
                    item.minValue = 0
                    item.maxValue = 100
                    return true
                  }
                  if (result[0].value > result[1].value) {
                    item.maxValue = +result[0].value
                    item.minValue = +result[1].value
                  } else {
                    item.maxValue = +result[1].value
                    item.minValue = +result[0].value
                  }

                  this.sliderArr.push(item)
                } else if (item.valueType === '4') {
                  item.isEdit = true
                  this.inputArr.push(item)
                }
              }
            } catch (error) {}

            this.paramsArr.push(
              ...this.switchArr,
              ...this.selectArr,
              ...this.sliderArr,
              ...this.inputArr
            )
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => console.log(e))
    },
    descChange(item) {
      this.showLoad()
      let params = {
        devSn: this.devSn,
        options: [
          {
            key: item.optionKey,
            value: item.optionValue + ''
          }
        ]
      }
      setOptions(params)
        .then(data => {
          if (data.code === '00000000') {
            setTimeout(() => {
              this.loadDeviceOptions()
            }, 300)
          } else {
            this.errorMessage(data.message)
          }
          this.closeLoad()
        })
        .catch(e => {
          this.closeLoad()
        })
    }
  },
  mounted() {
    this.loadDeviceOptions()
  }
}
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/deviceManager/deviceCmp/deviceSetting.vue